<template>
   <admin-mission-plan-edit  ref="editPlan" :missionPlan="plan" />
</template>

<script lang="ts">
import Vue from 'vue'
//@ts-ignore
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import {IMissionPlan} from '@/models/iris/missionPlan/IMissionPlan'
import AdminMissionPlanEdit from '@/components/admin/missionPlanTemplate/AdminMissionPlan.vue'

@Component({
  name: 'AdminMissionPlan',
  components:{AdminMissionPlanEdit}
})
export default class AdminMissionPlan extends Vue {  
  
  //Mission plan data
  plan!:IMissionPlan

  /*get stagingMissionPlan() {
      return this.currentDetailMission.mission.missionPlanStaging
  }

  get stagingMissionPlanLoaded(){
    return this.currentDetailMission.mission._missionPlanLoaded
  }

  get hasMissionStagingCreated(){
    return this.stagingMissionPlanLoaded && this.stagingMissionPlan &&  this.stagingMissionPlan.id > 0
  }*/

  /*Cycle de vie*/
  created() {  
      //this.plan = JSON.parse(this.stagingMissionPlan!.json)
      //if(this.$refs.editPlan) this.$refs.editPlan.reset()    
  }

  
}
</script>
